export const sendAuthTokenAsJSMessage = (authToken, email) => {
  if (window.opener) {
    window.opener.postMessage({ authToken: authToken, email: email }, "*"); // Use '*' for demo or specify origin
    window.close(); // Close the pop-up window after sending the token
  }
};
